export default "__VITE_PUBLIC_ASSET__757e419a__"